<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ isEditMode ? "Editar Frecuencia" : "Agregar Frecuencia" }}
</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Tipo</mat-label>
      <mat-select
        [(ngModel)]="currentCreateSubRouteFrequency.type"
        name="type"
        (selectionChange)="onTypeChange($event.value)"
      >
        <mat-option value="W">Semanal</mat-option>
        <mat-option value="Q">Quincenal</mat-option>
        <mat-option value="M">Mensual</mat-option>
        <!-- <mat-option value="P">Periódico</mat-option> -->
        <mat-option value="C">Personalizado</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-span-2" *ngIf="showDateField">
      <mat-label>Fechas</mat-label>
      <input
        matInput
        [(ngModel)]="currentCreateSubRouteFrequency.dates" 
        name="dates"
        placeholder="Selecciona una fecha"
        [matDatepicker]="picker"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <!-- Días -->
    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Días</mat-label>
      <mat-select
        [(ngModel)]="currentCreateSubRouteFrequency.days"
        name="days"
        multiple
        required
      >
      <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
      </mat-select>
    </mat-form-field>


    <!-- <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Socios</mat-label>
      <mat-select
        [(ngModel)]="currentCreateSubRouteFrequency.businessPartners"
        name="businessPartners"
        multiple
        required
      >
        <mat-option>
          <input
            matInput
            [(ngModel)]="filterText"
            name="filterText"
            placeholder="Buscar..."
            (input)="filterBusinessPartners()"
            class="filter-input"
            style="width: 100%;"
            (click)="$event.stopPropagation()" 
          />
        </mat-option>
        
        <mat-option *ngFor="let partner of filteredBusinessPartnerList" [value]="partner._id">
          {{ partner.name }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
    


    <div class="col-span-2">
      <label for="group-select">Clientes</label>
      <ng-select
        [(ngModel)]="currentCreateSubRouteFrequency.businessPartners"
        [items]="businessPartnerList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        [multiple]="true"
        placeholder="Seleccione los clientes"
        name="businessPartnerId"
        [appendTo]="'body'"
        [loading]="isLoading" 
      >
      </ng-select>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
    {{ isEditMode ? "Actualizar" : "Guardar" }}
  </button>
</mat-dialog-actions>
